import React from 'react';
import { PfErrorUtilsProvider } from '../ErrorUtilsContext';
export const UtilsProvider = ({
  utils,
  children
}) => {
  return /*#__PURE__*/React.createElement(PfErrorUtilsProvider, {
    errorUtils: utils.errorUtils
  }, children);
};